export const enum SnChannelType {
  User = 'user',
  Pair = 'pair',
  Team = 'team',
  Organization = 'organization',
}
